export default "__VITE_ASSET__BF9LZ55m__"